import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { City } from "../../types/city";
import { getCitiesApi } from "../../api/citiesApi";

interface CityState {
  cities: City[];
  loading: boolean;
  error: string | null;
}

const initialState: CityState = {
  cities: [],
  loading: false,
  error: null,
};

export const fetchCities = createAsyncThunk<City[], void, { rejectValue: string }>(
  "cities/fetchCities",
  async (_, { rejectWithValue }) => {
    try {
      return await getCitiesApi();
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch cities");
    }
  },
);

const citySlice = createSlice({
  name: "cities",
  initialState,
  reducers: {
    clearCitiesError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action: PayloadAction<City[]>) => {
        state.loading = false;
        state.cities = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch cities";
      });
  },
});

export const { clearCitiesError } = citySlice.actions;
export default citySlice.reducer;
